import { createSelector } from 'reselect';
import { selectGallery, selectCountOfSearchResults } from './fromState';

const selectNoSearchResults = createSelector(
    [selectGallery, selectCountOfSearchResults],
    (gallery, countOfSearchResults) => gallery && !countOfSearchResults
);

export default selectNoSearchResults;
